import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { NgbActiveModal, NgbAlert, NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  SecurityCfg
} from 'it/primatoo/openapi/api/org/schemas/application/getsecurityconfigdetailsresponse/SecurityCfg';
import { ApplicationService, CyberSecuritySecService } from '@pt/api-client';
import {
  GetApplicationForDetailsResponse
} from 'it/primatoo/openapi/api/org/schemas/application/getapplicationfordetailsresponse/GetApplicationForDetailsResponse';
import { CPE_REGEX, IoniconsFilled, IoniconsOutline, PtPermissions } from '@pt/pt-models';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Vendor } from 'it/primatoo/openapi/api/sec/schemas/cybersecurity/Vendor';
import { Product } from 'it/primatoo/openapi/api/sec/schemas/cybersecurity/Product';
import { Type } from 'it/primatoo/openapi/api/org/schemas/application/getsecurityconfigdetailsresponse/Type';
import { NgIf } from '@angular/common';
import { VendorProduct } from 'it/primatoo/openapi/api/org/schemas/application/VendorProduct';
import {
  UpdateAppSecurityConfigRequest
} from 'it/primatoo/openapi/api/org/schemas/application/updatesecurityconfigrequest/UpdateAppSecurityConfigRequest';
import { HasCveRequest } from 'it/primatoo/openapi/api/sec/schemas/cybersecurity/HasCveRequest';
import {
  DetailsSecurityToolTypeVendorOrProductComponent,
  VendorProductDialogResponse
} from '../../details-security-tool-type/details-security-tool-type-vendor-or-product.component';
import {
  DetailsSecurityToolTypeSupplierComponent
} from '../../details-security-tool-type/details-security-tool-type-supplier.component';
import { takeUntil } from 'rxjs/operators';
import { NgxPermissionsService } from 'ngx-permissions';
import { Store } from '@ngrx/store';
import { Confirm } from '../../../../decorators/confirm-decorator';

@Component({
  selector: 'pt-configure-cve-dialog',
  template: `
    <div class="modal-header">
      <div class="h4 modal-title">{{ "LABELS.CONFIGURATION" | translate }}</div>
    </div>

    <div class="modal-body">
      <p>{{ "MESSAGE.SECURITY_TOOL_TYPE_DIALOG" | translate }}</p>
      <form [formGroup]="formGroup">
        <div class="form-check">
          <input [value]="Type.VENDOR_PRODUCT"
                 class="form-check-input"
                 formControlName="option"
                 id="securityToolRadio3"
                 type="radio">
          <label class="form-check-label fw-bold" for="securityToolRadio3">
            {{ 'LABELS.SECURITY_TOOL_OPTION_' + Type.VENDOR_PRODUCT  | translate }}
          </label>
          <p>
            {{ 'MESSAGE.SECURITY_TOOL_OPTION_' + Type.VENDOR_PRODUCT  | translate }}
          </p>
        </div>

        <div #collapse="ngbCollapse" [(ngbCollapse)]="isVendorProductCollapsed" [animation]="true">
          <pt-details-security-tool-type-vendor-or-product
            (updateVendorProduct)="updateVendorProduct($event)"
            [version]="currentVersion"
            [product]="currentProduct"
            [vendor]="currentVendor">
          </pt-details-security-tool-type-vendor-or-product>
        </div>

        <div class="form-check">
          <input [value]="Type.CPE"
                 class="form-check-input"
                 formControlName="option"
                 id="securityToolRadio4"
                 type="radio">
          <label class="form-check-label fw-bold" for="securityToolRadio4">
            {{ 'LABELS.SECURITY_TOOL_OPTION_' + Type.CPE  | translate }}
          </label>
          <p>
            {{ 'MESSAGE.SECURITY_TOOL_OPTION_' + Type.CPE + '_1'  | translate }}
          </p>
          <p class="mb-0">
            {{ 'MESSAGE.SECURITY_TOOL_OPTION_' + Type.CPE + '_2'  | translate }}
            <a href="https://nvd.nist.gov/products/cpe/search" target='_blank'>https://nvd.nist.gov/ </a>
          </p>
          <p class="text-success">
            {{ 'MESSAGE.SECURITY_TOOL_OPTION_' + Type.CPE + '_3'  | translate }}

          </p>
        </div>

        <div #collapse="ngbCollapse" [(ngbCollapse)]="isCVECollapsed" [animation]="true">
          <div class="cpe">
            <div class="mb-3">
              <form [formGroup]="currentCpeForm">
                <label>
                  {{ 'LABELS.CPE' | translate }}
                </label>

                <div class="input-group input-group-sm mb-3">
                  <input type="text"
                         [class.is-invalid]='currentCpeForm.invalid'
                         class="form-control"
                         placeholder=""
                         formControlName="cpe">
                </div>
              </form>

            </div>
          </div>
        </div>

        <div class="form-check">
          <input [value]="Type.BOM"
                 class="form-check-input"
                 formControlName="option"
                 id="securityToolRadio2"
                 type="radio">
          <label class="form-check-label fw-bold" for="securityToolRadio2">
            {{ 'LABELS.SECURITY_TOOL_OPTION_' + Type.BOM  | translate }}
          </label>
          <p>
            {{ 'MESSAGE.SECURITY_TOOL_OPTION_' + Type.BOM  | translate }}
          </p>
        </div>

        <div #collapse="ngbCollapse" [(ngbCollapse)]="isSupplierCollapsed" [animation]="true">
          <pt-details-security-tool-type-supplier
            (uploadBom)="uploadBom($event)"
            [bomFileErrorMessage]="currentBomFileError"
            [bomFileName]="currentBomFileName">
          </pt-details-security-tool-type-supplier>
        </div>
      </form>

      <ngb-alert *ngIf='isChangeVendorOrProduct'
                 [animation]='true'
                 [dismissible]='false'
                 [type]="'warning'"
                 style="margin-left: 20px !important; padding: 2px 5px;">
        {{ 'MESSAGE.SECURITY_TOOL_CHANGE_CONFIGURATION_INFO' | translate }}
      </ngb-alert>
    </div>

    <div class="modal-footer">
      <div class="w-100 d-flex justify-content-end">

        <button type='button' class='btn btn-danger btn-sm me-auto'
                *ngIf="securityCfg?.type"
                (click)='removeSecurityToolType()'>
          Rimuovi Configurazione
        </button>

        <button (click)="save()"
                [disabled]="invalidForm || loading"
                class="btn btn-sm btn-primary me-2">
          <div class='spinner-border' role='status'
               *ngIf="loading" style="width: 13px; height: 13px; border-width: 2px">
            <span class='visually-hidden'>Loading...</span>
          </div>
          {{ "BUTTON.SAVE" | translate }}
        </button>

        <button (click)="close()"
                class="btn btn-sm btn-outline-secondary"
                id="{{cancelSecurityToolId}}">
          {{ "BUTTON.CANCEL" | translate }}
        </button>
      </div>
    </div>
  `,
  styleUrls: [`configure-cve-dialog.component.scss`],
  imports: [
    TranslateModule,
    NgIf,
    NgbAlert,
    ReactiveFormsModule,
    NgbCollapse,
    DetailsSecurityToolTypeVendorOrProductComponent,
    DetailsSecurityToolTypeSupplierComponent
  ],
  standalone: true
})
export class ConfigureCveDialogComponent implements OnDestroy {
  private destroy$ = new Subject<boolean>();
  public appDetails!: GetApplicationForDetailsResponse;
  public cancelSecurityToolId = 'cancelSecurityToolId';
  public IconTrash = IoniconsFilled.trash;
  public IconWarning = IoniconsOutline.warning;
  public close$ = new Subject<{ message?: string, reload: boolean }>();

  public formGroup: FormGroup;
  public currentCpeForm: FormGroup;
  public securityCfg?: SecurityCfg;
  public Type = Type;
  public isInstructionCollapsed = true;
  public isSupplierCollapsed = true;
  public isVendorProductCollapsed = true;
  public isCVECollapsed = true;

  public loading = false;
  public invalidForm = true;
  public currentBomFileName?: string;
  public currentBomFileError?: string;
  public currentVendor?: Vendor;
  public currentProduct?: Product;
  public currentVersion?: string;
  public currentCpe?: string;
  public currentType?: Type;
  public isChangeVendorOrProduct = false;
  public moduleActive = false;
  private destroy: Subject<boolean> = new Subject<boolean>();

  constructor(public activeModal: NgbActiveModal,
              private translateService: TranslateService,
              private store: Store,
              private cyberSecuritySecService: CyberSecuritySecService,
              private applicationService: ApplicationService,
              private permissionService: NgxPermissionsService
  ) {

    this.currentCpeForm = new FormGroup({
      cpe: new FormControl(null, [Validators.pattern(CPE_REGEX)])
    });
    this.formGroup = new FormGroup({
      option: new FormControl(null)
    });


    this.currentCpeForm.valueChanges.pipe(
      takeUntil(this.destroy)
    ).subscribe(() => {
      this.currentCpe = this.currentCpeForm.controls.cpe.value;
      this.alignForm();
    });

    this.formGroup.valueChanges.pipe(
      takeUntil(this.destroy)
    ).subscribe(() => {
      this.alignForm();
      this.currentType = this.formGroup.controls.option.value;
    });

    this.moduleActive = !!this.permissionService.getPermission(PtPermissions.ACTIVE_MODULE_CYBERSEC);
  }

  load(appDetails: GetApplicationForDetailsResponse) {
    this.appDetails = appDetails;
    this.securityCfg = undefined;
    this.currentVendor = undefined;
    this.currentProduct = undefined;
    this.currentVersion = undefined;
    this.currentBomFileName = undefined;
    this.currentCpe = undefined;

    this.applicationService.getSecurityConfig(this.appDetails.id).subscribe({
      next: (response: SecurityCfg) => {
        this.securityCfg = response;

        this.formGroup.setValue({
          option: response.type
        });
        if (response.cpeName) {
          this.currentCpe = response.cpeName;
        }

        if (response.vendorProduct) {
          this.currentVersion = response.vendorProduct.version;
          this.currentProduct = {
            name: response.vendorProduct.productName,
            uuid: response.vendorProduct.product
          };
          this.currentVendor = {
            name: response.vendorProduct.vendorName,
            uuid: response.vendorProduct.vendor
          };
        }

        if (response.bomFileName) {
          this.currentBomFileName = response.bomFileName;
        }

        this.currentCpeForm.controls.cpe.setValue(this.currentCpe, { emitEvent: false });

        this.alignForm();
      }, error: () => {
        this.formGroup.disable();
      }
    });

  }

  ngOnDestroy(): void {
    this.close();
  }


  close() {
    this.close$.next({ reload: false });
    // this.activeModal.close(false);
    this.destroy$.next(true);
  }


  @Confirm({
    title: 'Rimuovi Configurazione',
    message: 'Sei sicuro di voler eliminare la configurazione?'
  })
  removeSecurityToolType() {
    this.invalidForm = true;
    this.applicationService.updateSecurityConfig(this.appDetails.id, {
      securityCfgType: null,
      vendorProduct: null
    }).subscribe({
      next: () => {
        this.invalidForm = false;
        this.close$.next({ reload: true });
      }, error: () => {
        this.invalidForm = false;
        this.close$.next({ reload: false });
      }
    });
  }

  updateVendorProduct(response: VendorProductDialogResponse) {
    this.currentProduct = response.product;
    this.currentVendor = response.vendor;
    this.currentVersion = response.version;
    this.alignForm();
  }

  private alignForm() {

    const optionValue: Type | undefined = this.formGroup.controls.option.value;

    this.invalidForm = true;
    switch (optionValue) {
      // Software sviluppato internamente/fornitore
      case Type.BOM:
        this.openBOM();
        if (this.currentBomFileName) {
          this.invalidForm = false;
        }
        break;

      // Prodotto a scaffale
      case Type.VENDOR_PRODUCT:
        this.currentBomFileError = undefined;
        this.openVendorProduct();
        if (!!this.currentVendor && !!this.currentProduct && !!this.currentVersion) {
          this.invalidForm = false;
        }
        break;
      case Type.CPE:
        this.openCPE();
        this.invalidForm = this.currentCpeForm.invalid;
        // if (this.currentCpe?.length > 0) {
        //   this.invalidForm = false;
        // }
        break;

      // Software monitorato tramite altro strumento
      case Type.EXT:
        this.currentBomFileError = undefined;
        this.isInstructionCollapsed = true;
        this.isVendorProductCollapsed = true;
        this.isSupplierCollapsed = true;
        this.isCVECollapsed = true;
        this.invalidForm = false;
        break;
    }

    this.isChangeVendorOrProduct =
      optionValue !== this.securityCfg.type
      || this.securityCfg?.vendorProduct?.vendor !== this.currentVendor?.uuid
      || this.securityCfg?.vendorProduct?.product !== this.currentProduct?.uuid
      || this.securityCfg?.vendorProduct?.version !== this.currentVersion
      || this.securityCfg?.cpeName !== this.currentCpe
      || (!!this.currentBomFileName && this.securityCfg?.bomFileName !== this.currentBomFileName)
    ;

  }


  openCPE() {
    this.isInstructionCollapsed = true;
    this.isVendorProductCollapsed = true;
    this.isSupplierCollapsed = true;
    this.isCVECollapsed = false;
  }


  /**
   * Prodotto a scaffale
   */
  openVendorProduct() {
    this.isInstructionCollapsed = true;
    this.isVendorProductCollapsed = false;
    this.isSupplierCollapsed = true;
    this.isCVECollapsed = true;
  }

  /**
   * Software sviluppato internamente/fornitore
   */
  openBOM() {
    this.isInstructionCollapsed = true;
    this.isVendorProductCollapsed = true;
    this.isSupplierCollapsed = false;
    this.isCVECollapsed = true;
  }

  uploadBom($event: File) {
    this.currentBomFileError = undefined;
    this.currentBomFileName = undefined;
    this.applicationService.uploadBom(this.appDetails.id, $event).subscribe({
      next: () => {
        this.currentBomFileName = $event.name;
        this.alignForm();
      }, error: (e) => {
        if (e?.error?.reason) {
          this.currentBomFileError = e?.error?.reason;
        } else {
          this.translateService.stream('MESSAGE.BOM_INVALID_FILE').subscribe((message) => {
            this.currentBomFileError = message;
          });

        }
        this.currentBomFileName = undefined;
        this.alignForm();
      }
    });
  }


  save() {
    this.invalidForm = true;
    const securityCfgType: Type = this.formGroup.controls.option.value;
    const vendorProduct: VendorProduct = securityCfgType === Type.VENDOR_PRODUCT ? {
      vendor: this.currentVendor.uuid,
      product: this.currentProduct.uuid,
      vendorName: this.currentVendor.name,
      productName: this.currentProduct.name,
      version: this.currentVersion
    } : undefined;

    const cpeName: string = this.currentCpeForm.controls.cpe.value;

    const request: UpdateAppSecurityConfigRequest = {
      securityCfgType,
      vendorProduct,
      cpeName
    };

    this.loading = true;
    switch (securityCfgType) {
      case Type.CPE:
      case Type.VENDOR_PRODUCT:
        this.applicationService.updateSecurityConfig(this.appDetails.id, request).subscribe({
          next: () => {
            this.processSaveCpeOrVendorAndProduct(request);
          }, error: () => {
            this.invalidForm = false;
            this.loading = false;
            this.failRequestHandler();
            // this.modalRef?.close();
          }
        });
        break;
      default:
        this.processDefaultSave(request);
    }

  }

  private processDefaultSave(request: UpdateAppSecurityConfigRequest) {
    this.applicationService.updateSecurityConfig(this.appDetails.id, request).subscribe({
      next: () => {
        this.invalidForm = false;
        this.close$.next({ reload: true });
        this.loading = false;
      }, error: () => {
        this.invalidForm = false;
        this.loading = false;
        this.failRequestHandler();
        // this.closeSuccess$.next();

        // this.modalRef?.close(true);
      }
    });
  }

  private missingCVE() {
    this.close$.next({ message: 'MESSAGE.MISSING_CVE', reload: false });
    this.loading = false;
  }

  private failCheckCVE() {
    this.close$.next({ message: 'MESSAGE.FAIL_CHECK_CVE', reload: false });
    this.loading = false;
  }

  private processSaveCpeOrVendorAndProduct(request: UpdateAppSecurityConfigRequest) {

    switch (true) {
      case request.securityCfgType === Type.CPE && !!request.cpeName:
        this.cyberSecuritySecService.checkVendorAndProduct({ cpe: request.cpeName })
          .subscribe((r) => {
            if (r.hasCve) {
              this.invalidForm = false;
              this.close$.next(null);
              this.loading = false;
            } else {
              this.invalidForm = false;
              this.loading = false;
              this.missingCVE();
            }
          }, () => {
            this.failCheckCVE();
          });
        break;

      case request.securityCfgType === Type.VENDOR_PRODUCT && !!request.vendorProduct:
        const vpRequest: HasCveRequest = {
          params: {
            vendorName: request.vendorProduct.vendorName,
            productName: request.vendorProduct.productName,
            version: request.vendorProduct.version
          }
        };
        this.cyberSecuritySecService.checkVendorAndProduct(vpRequest)
          .subscribe((r) => {
            if (r.hasCve) {
              this.invalidForm = false;
              this.close$.next(null);
              this.loading = false;
            } else {
              this.invalidForm = false;
              this.loading = false;
              this.missingCVE();
            }
          }, () => {
            this.failCheckCVE();
          });
        break;
      default:
        this.loading = false;
    }
  }

  private failRequestHandler() {
    this.close$.next({ message: 'MESSAGE.CVE_DIALOG_REQUEST_FAIL', reload: false });
    this.loading = false;
  }
}
